import * as React from "react";
import { RichTextArea } from "@grandvisionhq/common";
import { Heading } from "@grandvisionhq/elements";
import { compose } from "@grandvisionhq/utils";
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withHidableContent } from "../../../../hocs/hocs/with-hidable-content.js";
import { withBloomreachData } from "../../../../hocs/hocs/with-bloomreach-data.js";
import { withEditableContent } from "../../../../hocs/hocs/with-editable-content.js";
import { withAnchor } from "../../../../hocs/hocs/with-anchor.js";
import { useBloomreachRichText } from "../../../../hooks/hooks/use-bloomreach-rich-text.js";
const CmsRichText = ({ page, content, meta, template }) => {
  const richText = useBloomreachRichText(content.content?.value);
  if (!richText) {
    return null;
  }
  switch (template) {
    case "default":
      return /* @__PURE__ */ React.createElement(
        RichTextArea,
        {
          content: richText,
          textColor: meta.textColor,
          backgroundColor: meta.backgroundColor,
          "data-t": "rich-text"
        }
      );
    // Full-width template to display content in full container width.
    case "full-width":
      return /* @__PURE__ */ React.createElement(
        RichTextArea,
        {
          content: richText,
          textColor: meta.textColor,
          backgroundColor: meta.backgroundColor,
          fullWidth: true,
          "data-t": "rich-text"
        }
      );
    // Modal template is only added to be able to retrieve the content from the pageModel.
    case "modal":
      return page.isPreview() ? /* @__PURE__ */ React.createElement(RichTextArea, { content: richText }) : null;
    default:
      return /* @__PURE__ */ React.createElement(Heading, { variant: "subheading1" }, "RichText component of type ", template, " not defined in RichTextCollection");
  }
};
const RichText = compose(
  withBreakpointVisibility,
  withHidableContent,
  withBloomreachData,
  withEditableContent,
  withAnchor
)(CmsRichText);
export {
  CmsRichText,
  RichText as default
};
//# sourceMappingURL=RichText.js.map
